export default "__VITE_ASSET__BVCIXu6a__"